module.exports = __webpack_public_path__ + "assets/img/order_list_empty.d776733f.png";